module.exports = __webpack_public_path__ + "static/media/logo_urgently_dark.62a93f28.svg";